import { CustomRoute } from "@/interfaces";
import { Bell, FileText, User } from "lucide-react";
import React from "react";

const PowerBiPage = React.lazy(() => import("@/modules/SuperAdmin/PowerBi"));
const PowerBiViewer = React.lazy(() => import("@/modules/SuperAdmin/PowerBi/PowerBiViewer"));
const EditProfile = React.lazy(() => import("../modules/Profile/EditProfile"));
const AllNotifications = React.lazy(() => import("../modules/Notifications/AllNotifications"));

// PowerBiAdmin is restricted to the Power BI tab only, plus the shared Profile/Notifications
// utility routes every logged-in role gets.
const powerBiAdminRoutes: CustomRoute[] = [
  {
    // Every role router needs an explicit "/" landing route — post-login redirects target "/",
    // and the catch-all otherwise bounces "/" back to itself, leaving a blank page.
    path: "/",
    id: "PowerBiAdmin",
    element: <PowerBiPage />,
    menuName: "Power BI",
    hideInMenu: true,
    highlightOn: ["powerbi"],
  },
  {
    path: "/powerbi",
    id: "PowerBiAdmin",
    element: <PowerBiPage />,
    menuName: "Power BI",
    icon: FileText,
    highlightOn: ["powerbi"],
  },
  {
    path: "/powerbi/view/:id",
    id: "PowerBiAdmin",
    element: <PowerBiViewer />,
    menuName: "Power BI Viewer",
    hideInMenu: true,
    highlightOn: ["powerbi"],
  },
  {
    path: "/notifications",
    id: "PowerBiAdmin",
    element: <AllNotifications />,
    menuName: "Notifications",
    icon: Bell,
    highlightOn: ["notifications"],
  },
  {
    path: "/profile",
    id: "PowerBiAdmin",
    element: <EditProfile />,
    menuName: "Profile",
    icon: User,
    highlightOn: ["profile"],
  },
];

export default powerBiAdminRoutes;
